<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="公司名称" prop="companyName" class="sj">
					<Input v-model="formValidate.companyName" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="联系方式1" prop="phone1" class="sj">
					<Input v-model="formValidate.phone1" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="联系方式2" prop="phone2" class="sj">
					<Input v-model="formValidate.phone2" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="联系方式3" prop="phone3" class="sj">
					<Input v-model="formValidate.phone3" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="住址" prop="address" class="sj">
					<Input v-model="formValidate.address" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="邮箱" prop="mailbox" class="sj">
					<Input v-model="formValidate.mailbox" placeholder="请输入邮箱" ></Input>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					companyName: '',
					phone1: '',
					phone2: '',
					phone3: '',
					address: '',
					mailbox: ''
				},
				ruleValidate: {
					companyName: [{
						required: true,
						message: '公司名称不能为空！！！',
						trigger: 'blur'
					}],
					phone1: [{
						required: true,
						message: '联系方式不能为空！！！',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '家庭住址不能为空！！！',
						trigger: 'blur'
					}],
					mailbox: [{
						required: true,
						message: '邮箱不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.formValidate.username=this.formValidate.phone
						this.$http.post(http.url+'/plat/platAdvSponsor/add', this.formValidate).then(res => {
							let data = res.data
							switch (data.code) {
								case 200:
									this.$Message.success('新增成功!');
									break;

								case 1000:
									this.$Message.error('登陆失效，请重新登陆!');
									setTimeout(function() {
										this.$router.push('/login')
									}, 1000);
									break;
								case 100:
									this.$Message.error('服务器异常!');
									break;
								case 101:
									this.$Message.error(data.error);
									break;
								default:
									this.$Message.error('服务器异常!');
									break;
							}

						}, res => {
							this.$Message.error('系统异常请刷新后重试!');
						})

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/sponsor/add.vue